module.exports = __webpack_public_path__ + "static/media/9.9dd9bbdb.jpg";